import { EventTarget } from 'cc';
import IClient from './IClient';
import IUserData from '../DataObject/IUserData';
import IInitData from '../DataObject/Game/IInitData';
import IEntryData from '../DataObject/Game/IEntryData';
import IHistoryData from '../DataObject/History/IHistoryData';
import IHistoryDetailData from '../DataObject/History/IHistoryDetailData';
import DataType from '../Config/DataStructure';
import TableModel from '../Model/TableModel';
import BettingModel from '../Model/BettingModel';
import Result from '../DataObject/Result';
import { OverviewDataType } from '../Config/GamePreviewDataType';
import { GamePreviewData } from '../Model/HallModel';

export default abstract class TableClient extends EventTarget implements IClient {
    protected entryData: IEntryData;
    protected initData: IInitData;

    constructor() {
        super();
    }

    public abstract login(): Promise<IUserData>;
    public abstract getInitData(): Promise<IInitData>;
    public abstract getEntryData(): Promise<IEntryData>;
    public abstract getHistoryData(pageIndex: number, pageSize: number, startTime: number): Promise<IHistoryData[]>;
    public abstract getHistoryDetailData(transactionID: string, roundID: number): Promise<IHistoryDetailData>;
    public abstract getGamePreviewData(hallID: number, gameID: string, playType: DataType.Enums.PlayType, rawGameData: OverviewDataType): GamePreviewData;
    public abstract getTableModel(data: DataType.Table.SummaryData): TableModel;
    public abstract getBettingModel(table: TableModel): BettingModel;
    public abstract getResult(data: DataType.Table.PlayerSettleData): Result;
}
